import * as React from 'react';

/** Whether the enclosing `DimeField` is required, so its label shows the asterisk and a control inside can announce it. */
export const FieldRequiredContext = React.createContext(false);
